import { useTickSoundInteraction } from '@/hooks';
import type { ReactNode } from 'react';

interface CardProps {
    title: string;
    content: string | ReactNode;
    ariaLabel: string;
}

export default function Card({ title, content, ariaLabel }: CardProps) {
    const { playTick } = useTickSoundInteraction();
    return (
        <div onKeyDown={(e) => {
            if (e.key === 'Enter') {
                playTick();
                e.preventDefault();
                e.stopPropagation();
            }
        }}
            tabIndex={3}
            data-interactive
            aria-label={ariaLabel}
            className="h-full flex flex-col widescreen:gap-[calc(24*var(--vh-unit))] gap-[calc(30*var(--vh-unit))] widescreen:h-[calc(216*var(--vh-unit))] fullscreen:w-[calc(400*var(--vw-unit))] w-[calc(360*var(--vw-unit))] widescreen:w-[calc(400*var(--vw-unit))] focus-border ">
            <div
                className={`rounded-[calc(8*var(--vh-unit))] border-[calc(1*var(--vh-unit))] border-[var(--color-primary-white)] bg-[var(--color-black-eaeaea)] px-[calc(24*var(--vw-unit))] py-[calc(16*var(--vh-unit))] text-[calc(22*var(--vh-unit))] leading-[calc(32*var(--vh-unit))] font-medium tracking-[calc(-0.44*var(--vh-unit))] text-[color:var(--color-text-black)]`}
            >
                {title}
            </div>
            <div className={`px-[calc(24*var(--vw-unit))] text-[color:var(--color-text-black)]`}>{content}</div>
        </div>
    );
}
